import { FluidStore } from '../../../utils/store/store.class';
import { Utils } from '../../../utils/utils';
import { RecordOf } from './table-state.store';

export interface TableDisplayStoreState {
  expandedRows?: RecordOf<boolean>;
  expandedGroups?: RecordOf<boolean>;
}
export class TableDisplayStateStore extends FluidStore<TableDisplayStoreState> {
  constructor(initialState: TableDisplayStoreState) {
    super({
      expandedRows: initialState.expandedRows || {},
      expandedGroups: initialState.expandedGroups || {},
    });
  }

  // ================================================================ //
  // -- Expansion State

  toggleRowExpanded(rowId: string, isExpanded?: boolean | undefined): void {
    const rowExpansionState = this.getValue(
      'expandedRows'
    ) as RecordOf<boolean>;
    this.setValue('expandedRows', {
      ...rowExpansionState,
      [rowId]: Utils.isNullOrUndefined(isExpanded)
        ? !this.isRowExpanded(rowId)
        : isExpanded,
    });
  }

  toggleGroupExpanded(groupId: string, isExpanded?: boolean | undefined): void {
    const groupExpansionState = this.getValue(
      'expandedGroups'
    ) as RecordOf<boolean>;
    this.setValue('expandedGroups', {
      ...groupExpansionState,
      [groupId]: Utils.isNullOrUndefined(isExpanded)
        ? !this.isGroupExpanded(groupId)
        : isExpanded,
    });
  }

  /**
   * Returns the row expansion state of the given rowId.
   * If record is null/undefined it is treated as expanded until it is explicitly false.
   *
   * @param rowId
   */
  isRowExpanded(rowId: string): boolean {
    return (this.getValue('expandedRows') as RecordOf<boolean>)?.[rowId];
  }

  /**
   * Returns the group expansion state of the given groupId.
   * If record is null/undefined it is treated as expanded until it is explicitly false.
   *
   * @param groupId
   */
  isGroupExpanded(groupId: string): boolean {
    const isGroupExpanded: boolean = (
      this.getValue('expandedGroups') as RecordOf<boolean>
    )?.[groupId];
    return isGroupExpanded || Utils.isNullOrUndefined(isGroupExpanded);
  }
}
